import React from "react";
import NotInAppNotice from "../../components/shared/NotInAppNotice";
import SafeImage from "../../components/shared/SafeImage";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import ModalBox from "../../components/shared/pageComponent/ModalBox";
import DataTable from "react-data-table-component";
import DummyIcon from "../../assets/images/user.jpg";
import { NavLink, withRouter } from "react-router-dom";
import HeadlineForm from "./HeadlineForm";
import { createHeadline, getNewsList, deleteNews } from "../../api/admin";
import { uploadViaPresign } from "../../api/upload";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Pagination from "react-js-pagination";

/**
 * Pull a displayable string out of an API error body. The API answers errors in
 * one shape (`{ statusCode, error, message, path, timestamp }`), and passing
 * that object straight to `toast()` renders NOTHING — which is how a failing
 * "Create" looked like a dead button rather than a rejected request.
 */
const errorMessage = (body) => {
  if (typeof body === "string") return body;
  if (body && typeof body.message === "string") return body.message;
  return "Something went wrong. Please try again.";
};

class HeadlineListing extends React.Component {
  constructor(props) {
    super(props);
    this.InputSwitch = React.createRef();
    this.state = {
      newsId: null,
      modal: false,
      selected: 1,
      isModalOpen: false,
      title: "",
      type: "text",
      video_url: null,
      description: "",
      website_link: "",
      news_photo: [],
      newsList: [],
      totalCounts: 0,
      limit: 10,
      activePage: 1,
      sort: false,
      sortBy: null,
    };
  }

  getNewsList = async (
    pageNumber,
    sortBy = this.state.sortBy,
    sortDir = this.state.sort
  ) => {
    const newsList = await this.props.getNewsList(
      pageNumber ? pageNumber : 1,
      sortBy,
      sortDir
    );
    this.setState({
      // GET /api/v1/admin/news resolves to `{ data, meta }`, not legacy's
      // `{ news, totalCounts }` — this component was still reading the old
      // field names, so the table always rendered empty despite the API
      // returning real rows.
      newsList: newsList && newsList.data,
      totalCounts: newsList && newsList.meta ? newsList.meta.total : 0,
    });
    this.props.setLoading(false);
  };

  async componentDidMount() {
    this.props.setLoading(true);
    this.props.setTitlePage("Headline Management");
    await this.getNewsList();
    this.props.setLoading(false);
  }

  activeType = (selected, type) =>
    this.setState({
      selected,
      type,
    });

  toggle = () =>
    this.setState({
      modal: !this.state.modal,
    });

  toggleModal = () =>
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    });

  columns = [
    {
      name: "Owner",
      selector: "authorName",
      sortable: true,
      cell: (row) => (
        <div className="user-wrapper">
          {row.authorId ? (
            <NavLink className="link-wrap" to={`/user-detail/${row.authorId}`}>
              <SafeImage height="33" width="33" alt={row.authorName} src={row.authorAvatarUrl || DummyIcon} />
              <span className="user-detail">
                <span className="name">{row.authorName}</span>
              </span>
            </NavLink>
          ) : (
            <span className="name">{row.authorName || "N/A"}</span>
          )}
        </div>
      ),
    },
    {
      name: "Title",
      selector: "title",
      center: true,
      cell: (row) => (
        <div className="podcast-wrapper">
          <span className="name">{row.title}</span>
        </div>
      ),
    },
    {
      name: "Video Url",
      selector: "videoUrl",
      center: true,
      cell: (row) =>
        row.videoUrl ? (
          <a className="truncate-cell" href={row.videoUrl} target="_blank" rel="noopener noreferrer">
            {row.videoUrl}
          </a>
        ) : (
          <div className="podcast-wrapper">
            <span className="name">N/A</span>
          </div>
        ),
    },
    {
      name: "Description",
      selector: "description",
      center: true,
      cell: (row) => (
        <div className="podcast-wrapper">
          <span className="name">{row.description || "N/A"}</span>
        </div>
      ),
    },
    {
      name: "Website Link",
      selector: "websiteLink",
      center: true,
      cell: (row) =>
        row.websiteLink ? (
          <a className="truncate-cell" href={row.websiteLink} target="_blank" rel="noopener noreferrer">
            {row.websiteLink}
          </a>
        ) : (
          <div className="podcast-wrapper">
            <span className="name">N/A</span>
          </div>
        ),
    },
    {
      name: "News Photo",
      selector: "newsPhotoUrls",
      center: true,
      cell: (row) => (
        <div className="podcast-wrapper">
          <span className="name">
            {row.newsPhotoUrls ? row.newsPhotoUrls.length : "N/A"}
          </span>
        </div>
      ),
    },
    {
      name: "Action",
      selector: "action",
      center: true,
      cell: (row) => (
        <button
          className="RemoveBtn"
          onClick={() => this.selectIdDelete(row.id)}
        >
          Remove
        </button>
      ),
    },
  ];

  handleChange = (e) => {
    const { value, name } = e.target;
    this.setState({ [name]: value });
    if (e.target.value === "") {
      e.target.classList.add("error");
    } else {
      e.target.classList.remove("error");
    }
  };

  // Both uploads go through the API's presigned-URL flow. They previously read
  // raw IAM keys out of `awsCredentials.s3`, but `getAwsCredentials` is a stub
  // returning `false` (the new API never ships bucket credentials to the
  // browser) — so this threw on `.s3` of `false`, the catch returned null, and
  // Create then posted a headline with no media and got a 400. That is the
  // other half of "I press Create and nothing happens".
  uploadVideoOns3 = async () => {
    try {
      this.props.setLoading(true);
      return await uploadViaPresign(this.state.video_url, "video");
    } catch (error) {
      toast(errorMessage(error?.message), { type: "error" });
      return null;
    } finally {
      this.props.setLoading(false);
    }
  };

  uploadPhotosOns3 = async () => {
    try {
      this.props.setLoading(true);
      const news_photo = [];
      for await (let file of this.state.news_photo) {
        news_photo.push(await uploadViaPresign(file, "poster"));
      }
      return news_photo;
    } catch (error) {
      toast(errorMessage(error?.message), { type: "error" });
      return null;
    } finally {
      this.props.setLoading(false);
    }
  };

  createHeadline = async () => {
    const { selected, title, type, description, website_link } = this.state;
    if (!title && !type && !description && !website_link) {
      return;
    } else if (!title) {
      toast("Please enter news title!", { type: "error" });
      return;
    }
    this.props.setLoading(true);
    const data = {
      title: title,
      type: type,
      website_link: website_link,
    };
    if (selected === 1) {
      data.description = description;
    }
    // A failed upload must ABORT: the API requires videoUrl/newsPhoto for these
    // types, so posting without them is a guaranteed 400 that used to surface as
    // nothing at all. Say what went wrong instead of firing a doomed request.
    if (selected === 2) {
      const video_url = await this.uploadVideoOns3();
      if (!video_url) {
        this.props.setLoading(false);
        return;
      }
      data.video_url = video_url;
    }
    if (selected === 3) {
      const news_photo = await this.uploadPhotosOns3();
      if (!news_photo || news_photo.length === 0) {
        this.props.setLoading(false);
        return;
      }
      data.news_photo = news_photo;
    }
    const create = await this.props.createHeadline(data);
    if (create && create.status === 201) {
      toast("News created successfully!");
      this.setState({
        isModalOpen: false,
        title: "",
        type: "text",
        video_url: null,
        description: "",
        website_link: "",
        news_photo: [],
      });
      this.props.setLoading(true);
      this.getNewsList();
    } else if (create && create.data) {
      toast(errorMessage(create.data), { type: "error" });
    }
    this.props.setLoading(false);
  };

  deleteHeadline = async () => {
    this.toggle();
    this.props.setLoading(true);
    const remove = await this.props.deleteNews(this.state.newsId);
    if (remove && remove.status === 200) {
      this.props.setLoading(true);
      this.getNewsList();
    } else if (remove && remove.data) {
      toast(errorMessage(remove.data), { type: "error" });
    }
    this.props.setLoading(false);
  };

  selectIdDelete = (newsId) => {
    this.toggle();
    this.setState({ newsId });
  };

  validateDurationVideo(url, callback) {
    const video = document.createElement("video");
    video.preload = "metadata";
    video.onloadedmetadata = () => {
      URL.revokeObjectURL(video.src);
      if (video.duration > 60) {
        callback(false);
      } else {
        callback(true);
      }
    };
    video.src = URL.createObjectURL(url);
  }
  onVideoChange = (file) => {
    // The picked File is uploaded as-is: the presign flow names the object
    // server-side (a UUID key under the caller's namespace), so the old
    // FormData round-trip that only renamed it served no purpose.
    const videoFile = file.target.files[0];
    if (!videoFile) return;
    this.validateDurationVideo(videoFile, (status) => {
      if (!status) {
        return toast("You cannot upload a video longer than 60 seconds", {
          type: "warning",
        });
      }
      this.setState({ video_url: videoFile });
    });
  };
  onPhotosChange = (file) => {
    const photoFile = file.target.files[0];
    if (this.state.news_photo.length === 5) {
      return toast("News cannot contain more that 5 images", { type: "info" });
    }
    this.setState({ news_photo: [...this.state.news_photo, photoFile] });
  };

  removePhoto = (index) => {
    this.state.news_photo.splice(index, 1);
    this.setState({ news_photo: this.state.news_photo });
  };

  handlePageChange(pageNumber) {
    this.setState({ activePage: pageNumber }, () => {
      this.getNewsList(pageNumber);
    });
    this.props.setLoading(true);
  }

  onSort = (e) => {
    this.setState(
      {
        sort: !this.state.sort,
        sortBy: e.selector,
      },
      () => {
        this.getNewsList(this.state.activePage, e.selector, this.state.sort);
      }
    );
    this.props.setLoading(true);
  };

  render() {
    const {
      selected,
      title,
      video_url,
      description,
      website_link,
      news_photo,
      newsList,
      limit,
      totalCounts,
      activePage,
    } = this.state;
    return (
      <>
        <NotInAppNotice>
          The app has no headlines or news surface — nothing published here reaches a
          user yet.
        </NotInAppNotice>
        <div className="header-section minus-space">
          <div className="create-podcast">
            <Button color="primary" onClick={this.toggleModal}>
              Create Headline
            </Button>
            <ModalBox
              isOpen={this.state.isModalOpen}
              ModalTitle="Add Headlines"
              withHeader={true}
              toggle={this.toggleModal}
              className="modal-right"
            >
              <HeadlineForm
                loaded={this.props.loading}
                selected={selected}
                title={title}
                description={description}
                website_link={website_link}
                video_url={video_url}
                news_photo={news_photo}
                activeType={this.activeType}
                handleChange={this.handleChange}
                createHeadline={this.createHeadline}
                onVideoChange={this.onVideoChange}
                onPhotosChange={this.onPhotosChange}
                removePhoto={this.removePhoto}
              />
            </ModalBox>
          </div>
        </div>
        <DataTable
          title="Manage Headline"
          columns={this.columns}
          className="custom-table with-5-col"
          data={newsList}
          onSort={this.onSort}
        />
        {totalCounts > 0 && (
          <Pagination
            activePage={activePage}
            itemsCountPerPage={limit}
            totalItemsCount={totalCounts}
            pageRangeDisplayed={5}
            onChange={this.handlePageChange.bind(this)}
          />
        )}
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <ModalHeader toggle={this.toggle}>Delete News</ModalHeader>
          <ModalBody>Are you sure to delete the news</ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.deleteHeadline}>
              Yes, delete
            </Button>
            <Button color="secondary" onClick={this.toggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    admin: store.user,
  };
};

export default connect(mapStateToProps, {
  createHeadline,
  getNewsList,
  deleteNews,
})(withRouter(HeadlineListing));
